import {first} from 'rxjs/operators';
import {MatDialogRef} from '@angular/material/dialog';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {
  SourceCondition,
  SourceCustomExpression,
  SourceFunction,
} from './abstract-attribute-flow-control';
import {CustomExpressionParser} from '../../../../shared/custom-expression-parser/custom-expression-parser';
import {LanguageService} from '../../../../language/language.service';
import {DialogsService} from '../../../../shared/dialog/dialogs.service';
import {CacheService} from '../../../../cache/cache.service';

@Component({
  template: `
    <app-dialog>
      <app-dialog-title>
        <language
          key="CtrlAttributeFlowCustomExpressionDialogTitle"
          defaultValue="Add/Edit Custom Expression"
        ></language>
      </app-dialog-title>
      <button
        app-dialog-header-button
        mat-icon-button
        (click)="save()"
        class="mat-icon-button-primary-color"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        app-dialog-header-button
        mat-icon-button
        (click)="dialogRef.close(null)"
        class="mat-icon-button-error-color"
      >
        <mat-icon>undo</mat-icon>
      </button>
      <div mat-dialog-content>
        <mat-form-field>
          <textarea matInput [(ngModel)]="value"></textarea>
          <mat-label>
            <language
              key="CtrlAttributeFlowCustomExpressionDialogValuePlaceholder"
              defaultValue="Expression"
            ></language>
          </mat-label>
        </mat-form-field>
      </div>
    </app-dialog>
  `,
  styles: [
    'app-dialog { width: var(--mat-dialog-container-max-width); } mat-form-field { width: 100%; }',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttributeFlowCustomExpressionDialog {
  public set customExpression(customExpression: SourceCustomExpression) {
    this.value = customExpression.summary;
  }

  public value: string = '';

  constructor(
    public dialogRef: MatDialogRef<AttributeFlowCustomExpressionDialog>,
    private dialogsService: DialogsService,
    private cacheService: CacheService,
  ) {}

  save(): void {
    try {
      const expression: SourceCustomExpression = CustomExpressionParser.parse(this.value);
      if (expression === null) {
        throw 'Empty custom expression (null).';
      } else if (expression.customFunction instanceof SourceCondition) {
        throw 'Condition not allowed.';
      } else if (!(expression.customFunction instanceof SourceFunction)) {
        throw 'Only function is allowed.';
      }
      this.dialogRef.close(expression);
    } catch (e) {
      if (this.dialogsService != null && this.cacheService != null) {
        this.cacheService
          .getLanguageResource()
          .pipe(first())
          .subscribe(lr => {
            const title = LanguageService.translate(
              'CtrlAttributeFlowCustomExpressionDialogErrorTitle',
              'Error',
              lr,
            );
            let msg = LanguageService.translate(
              'CtrlAttributeFlowCustomExpressionDialogErrorMessage',
              'There occurred an error while parsing your custom expression.',
              lr,
            );
            this.dialogsService.webserviceError(e, title, msg, lr);
          });
      }
    }
  }
}
